import { Component, Input } from '@angular/core';

export type CompanyProfileLoadingState = 'loading' | 'error';

// Shared loading and load error state for the skinned company profiles.
// Copy is set through inputs; colours come from the --profile-* custom properties in the stylesheet.
@Component({
  selector: 'company-profile-loading',
  templateUrl: './company-profile-loading.component.html',
  styleUrls: ['./company-profile-loading.component.css'],
  standalone: false,
})
export class CompanyProfileLoadingComponent {
  @Input() state: CompanyProfileLoadingState = 'loading';
  @Input() eyebrow = 'COMPANY PROFILE';
  @Input() heading = 'Preparing your company view';
  @Input() subtitle = 'Bringing together the latest company signals.';
  @Input() iconClass = 'fal fa-building';
  @Input() errorHeading = 'We could not load this company';
  @Input() errorMessage = 'The company profile could not be loaded.';
  @Input() errorIconClass = 'fal fa-triangle-exclamation';
  /** Adds a full-width products and services row to the hero, for skins that show company-profile-offerings as a band. */
  @Input() offeringsBand = false;
}
